"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var chart_js_1 = require("chart.js");
var core_1 = require("@athena-portal/core");
var BaseChart = /** @class */ (function (_super) {
    __extends(BaseChart, _super);
    function BaseChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canvas = React.createRef();
        return _this;
    }
    BaseChart.prototype.getColors = function () {
        return [
            this.themeVars.purple,
            this.themeVars.orange,
            this.themeVars.yellow,
            this.themeVars.cyan,
            this.themeVars.blue,
            this.themeVars.pink,
            this.themeVars.indigo,
            this.themeVars.red,
            this.themeVars.green,
            this.themeVars.teal
        ];
    };
    BaseChart.prototype.componentDidMount = function () {
        new chart_js_1.Chart(this.canvas.current || '', {
            data: this.mapData(),
            type: this.getChartType(),
            options: this.getOptions()
        });
    };
    BaseChart.prototype.getOptions = function () {
        return {
            legend: {
                display: false
            },
            responsive: true,
            maintainAspectRatio: false,
            layout: {
                padding: {
                    left: 2,
                    right: 2,
                    top: 10,
                    bottom: 2
                }
            },
            elements: {
                arc: {
                    borderColor: this.themeVars.white,
                    borderWidth: 1
                }
            }
        };
    };
    BaseChart.prototype.mapData = function () {
        var data = [];
        var labels = [];
        this.props.data.forEach(function (dataset) {
            data.push(dataset.value);
            labels.push(dataset.label);
        });
        return {
            datasets: [{
                    data: data,
                    backgroundColor: this.getColors()
                }],
            labels: labels
        };
    };
    BaseChart.prototype.renderChart = function () {
        return React.createElement("div", { className: "canvas-container" },
            React.createElement("canvas", { ref: this.canvas }));
    };
    BaseChart.prototype.renderLabels = function () {
        var _this = this;
        return React.createElement("div", { className: "labels" },
            this.props.children,
            React.createElement("div", { className: "label" },
                React.createElement("table", { className: "tab" },
                    React.createElement("tbody", null, this.props.data.map(function (item, index) {
                        return React.createElement("tr", { key: item.label + item.value },
                            React.createElement("td", null,
                                React.createElement("div", { className: "color", style: _this.getLabelColorStyle(index) })),
                            React.createElement("td", { className: "text" }, item.label));
                    })))));
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ThemeVars),
        __metadata("design:type", core_1.ThemeVars)
    ], BaseChart.prototype, "themeVars", void 0);
    return BaseChart;
}(React.Component));
exports.default = BaseChart;
//# sourceMappingURL=BaseChart.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/charts/chartjs/BaseChart.js
// module id = 1017
// module chunks = 0